import { WORKSPACE_ROUTE_BASE } from './workspaceConfig';

function workspaceBase(projectId) {
    return `${WORKSPACE_ROUTE_BASE}/${projectId}`;
}

/** @returns {string} */
export function workspaceMedProjectModulesPath(projectId, moduleId) {
    return `${workspaceBase(projectId)}/modules/${moduleId}`;
}

/** @returns {string} */
export function workspaceMedProjectQuickEntriesPath(projectId) {
    return `${workspaceBase(projectId)}/quick-entries`;
}

/** @returns {string} */
export function workspaceMedProjectMembersPath(projectId) {
    return `${workspaceBase(projectId)}/members`;
}

/** @returns {string} */
export function workspaceMedProjectNoticesPath(projectId) {
    return `${workspaceBase(projectId)}/notices`;
}

/** @returns {string} */
export function workspaceMedProjectSettingPath(projectId) {
    return `${workspaceBase(projectId)}/setting`;
}
